goog.provide("shadow.js.shim.module$remark_gfm$default");
shadow.js.shim.module$remark_gfm$default = shadow.js.require(500, {}).default;
